// @flow
import { getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { compose, withProps } from 'react-recompose';
import isEqual from 'lodash/isEqual';

import type { DispatchProps, StateProps } from './AddMoneyWithCreditCard';
import AddMoneyWithCreditCard from './AddMoneyWithCreditCard';
import ValidationService from '../../lib/validation';
import I18n from '../../lib/i18n';
import { addMoney } from '../../modules/AddMoney';
import { isLoadingSelector } from '../../modules/LoadingStatus';
import type { StateType } from '../../modules/reducers';
import config from '../../config/';
import { getVisibleNumbers } from '../TopUp/lib';
import { customPaymentMeanSelector } from '../../modules/Customer/selectors';
import FormatService from '../../lib/format';

const { minCreditWalletAmount, maxCreditWalletAmount } = config;

const validate = ({ amount }) => ({
  amount: ValidationService.validateAddMoney(amount, minCreditWalletAmount, maxCreditWalletAmount),
});

const shouldError = ({ values, nextProps, props, initialRender }) => {
  if (initialRender) {
    return false;
  }
  if (isEqual(props, nextProps)) {
    return false;
  }
  const { amount: nextAmount } = nextProps;

  return nextAmount ? nextAmount.amount.length >= 1 : false;
};

const mapStateToProps = (state: StateType): StateProps => ({
  amount: getFormValues('addMoneyWithCreditCard')(state),
  isLoading: isLoadingSelector(state, 'addMoney'),
  paymentMean: customPaymentMeanSelector(state),
});

const mapDispatchToProps = (dispatch: Function): DispatchProps => ({
  onSubmit: values => {
    dispatch(addMoney(values.amount, 'WALLET'));
  },
});

const withWalletProps = ({ paymentMean }) => ({
  iconName: 'wallet',
  amountPlaceholder: FormatService.formatCentsToCurrency(0),
  currentBalanceText: I18n.t('Dashboard.AddMoneyWithCreditCard.wallet.currentBalance'),
  confirmText: I18n.t('Dashboard.AddMoneyWithCreditCard.wallet.confirm'),
  getModalBody: (amount: string) => {
    const amountToCents = Number(amount.replace(',', '.')) * 100;
    return I18n.t('Dashboard.AddMoneyWithCreditCard.wallet.modal.modalBody', {
      amount: FormatService.formatCentsToCurrency(amountToCents, true),
      cardNumber: getVisibleNumbers(paymentMean?.functionalId),
    });
  },
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({ form: 'addMoneyWithCreditCard', validate, shouldError }),
  withProps(withWalletProps)
);
export default enhance(AddMoneyWithCreditCard);
